import Tab from '@material/react-tab';
import TabBar from '@material/react-tab-bar';

import { Section } from 'components';

import './styles.scss';
import styled from 'styled-components';

interface SubmenuProps {
  areas: string[];
  areaIndex: number;
  onAreaClick: (index: number) => void;
}

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colors.dark_150};
  z-index: 1000;

  .mdc-tab-scroller__scroll-content {
    justify-content: center;
  }

  .mdc-tab {
    flex: 0;

    .mdc-tab-indicator > .mdc-tab-indicator__content--underline {
      height: 4px;
    }

    .mdc-tab__text-label {
      color: ${({ theme }) => theme.colors.primary_10};
      opacity: 1;
      font-weight: bold;
    }

    &.mdc-tab--active {
      .mdc-tab__text-label {
        color: ${({ theme }) => theme.colors.primary_400};
      }

      .mdc-tab-indicator__content--underline {
        background: ${({ theme }) => theme.colors.primary_400};
      }
    }
  }

  .mdc-tab__ripple::before,
  .mdc-tab__ripple::after {
    display: none;
  }
`;

const Submenu = ({ areas, areaIndex, onAreaClick }: SubmenuProps) => {
  return !!areas?.length ? (
    <Wrapper className="tab__dashboard-areas">
      <Section maxWidth={{ m: '100vw' }}>
        <TabBar activeIndex={areaIndex} handleActiveIndexUpdate={(index) => onAreaClick(index)}>
          {[...areas].map((area, index) => (
            <Tab key={`area-tab-${area}-${index.toString()}`} focusOnActivate={false}>
              <span className="mdc-tab__text-label">{area}</span>
            </Tab>
          ))}
        </TabBar>
      </Section>
    </Wrapper>
  ) : (
    <></>
  );
};

export default Submenu;
